"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var BillableTypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(BillableTypeResource, _super);
    function BillableTypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillableTypeResource.endpoint = '/billabletypes';
    BillableTypeResource.MODEL_NAME = 'billabletype';
    return BillableTypeResource;
}(base_1.default));
exports.default = BillableTypeResource;
//# sourceMappingURL=billabletype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/billabletype.js
// module id = 7IRr
// module chunks = 0